import { ENDPOINTS as ENDPOINTS_API } from "./endpoints/endpoints.api";
import { ENDPOINTS as ENDPOINTS_MOCKS } from "./endpoints/endpoints.mocks";

export const environment = {
  version: {
    full: "2.0.0",
    year: "2021",
  },

  environment: "local",
  production: false,
  // apiUrl: "", // LOCAL
  apiUrl: "https://dev.centromove.com", // DEV
  // apiUrl: "https://api.centromove.com", // PROD
  // endPoints: ENDPOINTS_MOCKS, // MOCK DATA
  endPoints: ENDPOINTS_API, // API DATA
  useMocks: false,
  defaultLanguage: "es",
  defaultCurrency: "€",
  languages: [{ label: "Español", key: "es" }],
  servicesConfig: {
    stripe: {
      publishableKey:
        "pk_test_51JSLGIGyaSOVRCsz39A4myeQa9OhBaHGfJESY7ivpsrB9zTwbJ34NYiKyZwlMPiO812dvTx6ErFOV8fGNSd4Upuk00nkYWxxJU",
    },
  },
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts